import { Box, Checkbox } from "@drone-js/core";
import type { FunctionComponent } from "react";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";
import { BasePropertyListing } from "./BasePropertyListing";
import type { BasePropertyList } from "./types";
import { useCheckboxListing } from "./useCheckboxListing";

interface CheckboxListingProps extends BasePropertyList {
    fromUrl?: boolean;
}

export const CheckboxListing: FunctionComponent<CheckboxListingProps> = ({ id, fromUrl = false, ...rest }) => {
    const {
        automaticPropertySelectionCms: { fromUrl: fromUrlLabel, fromUrlTooltip },
    } = usePropertySelectionViewModelValue();
    const { isSelected, toggle } = useCheckboxListing(id);

    return (
        <BasePropertyListing
            data-element-name="listing-card"
            data-property-id={id}
            badge={
                fromUrl
                    ? {
                          label: fromUrlLabel,
                          variant: "tertiary.neutral-1",
                          tooltip: {
                              title: fromUrlLabel,
                              content: fromUrlTooltip,
                          },
                          analytics: {
                              dataElementName: "choose-listing-from-url-badge",
                          },
                      }
                    : undefined
            }
            onClick={toggle}
            {...rest}
        >
            {!fromUrl && <Box />}
            <Box px="8">
                <Checkbox selection={isSelected ? "selected" : "unselected"} />
            </Box>
        </BasePropertyListing>
    );
};
